// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const API_VERSION = "/api/v1";
export const API_PREFIX_BUYER = "/b";
export const API_PREFIX_SUPPLIER = "/s";

export const API_ROUTES = {
	COMMON: {
		FIND: "/find",
		DETAILS: "/details",
	},
	API_KEYS: {
		KEYS: "/keys/",
		CREATE: "/keys/create",
		SEARCH: "/keys/search"
	},
	ORDERS: {
		CREATE: "/orders/create",
		CREATE_DRAFT: "/orders/draft",
		GET: "/orders",
		FIND: "/orders",
		DELETE: "/orders",
		CHANGE_STATUS: "/orders/find",
		EXPORT: "/orders/export",
		ALL_SUPPLIERS: "/orders/suppliers",
		CANCEL: "/orders/cancel",
		UPDATE: "/orders",
		STATUS: "/status"
	},
	SUBSCRIPTIONS: {
		CREATE: "/orders/create",
		GET: "/orders",
		FIND: "/orders",
		DELETE: "/orders",
		SUBSCRIPTION: "/subscription",
		PARTICIPATION:"/tender-participation",
	},
	SUPPLIER: {
		ANALYTICS: {
			GET: "/s/analytics",
		},
		PROFILE: {
			GET: "/s/profile",
			PUT: "/s/profile",
			UPDATE_PASSWORD: "/s/profile/update/password",
			DELETE: "/s/profile",
		},
		ORGANISATION: {
			GET_USERS: "/s/organizations",
			BASE_URL: "/s/organizations",
			INVITE_ACCEPT: "/s/invite/accept",
			ADDRESS: {
				BASE_URL: "/address",
				SEARCH: "/address/search?",
				CREATE: "/address",
				UPDATE: "/address",
				DELETE: "/address",
			},
			USERS: {
				BASE_URL: "/users",
				SEARCH: "/users/search?",
				INVITE: "/users/invite",
				DEACTIVATE: "/deactivate",
				ACTIVATE: "/activate"
			},
		},
		PRODUCTS: {
			SEARCH: "/s/products",
			DELETE: "/s/products",
			CREATE: "/s/products/register",
			UPLOAD: "/s/products/import",
			UPDATE: "/s/products/update",
			DOWNLOAD: "/s/products/export",
			VALIDATE: "/s/products/validate",
			UPLOADS_LEFT: "/s/products/uploads-left",
			REQUESTED_PRODUCT:"/s/products/requested-products",
			UPDATE_REQUESTED_PRODUCT: "/s/products/requested-products/update",
			PRODUCT_IMPORT: "/product/import",
			IMPORT_STATUS: "/import/status",
			RETRY_IMPORT: "/import/retry"

		},
		CATEGORY: {
			SEARCH: "/s/categories/search",
			DOWNLOAD: "/s/categories/export",
		},
		ADDRESS: {
			SEARCH: "/s/address/search?",
			FETCH: "/s/organizations/address",
			DELETE: "/s/address/delete?",
			CREATE: "/s/organizations/address",
		},
		TENDERS: {
			BASE_URL: "/s/tenders",
			SEARCH: "/s/tenders",
			DELETE: "/s/tenders/delete?",
			CREATE: "/s/tenders",
			DOWNLOAD: "/s/tenders/download",
			DOWNLOAD_ATTACHMENT: "/s/tenders",
			BUYERS_LIST: "/s/tenders/buyers/list",
			CATEGORY_LIST: "/s/tenders/categories/list",
		},
		CONTRACTS: {
			SEARCH: "/s/contracts",
			EXPORT_PRODUCTS: "/s/contracts/export"
		},
		TENDERS_PRODUCTS: {
			SEARCH: "/s/tender-products/search?",
			DELETE: "/s/tender-products/delete?",
			CREATE: "/s/tender-products",
			EXPORT: "/s/tenders",
		},
		APPROVALS: {
			CATEGORIES: "/s/approval/category",
		},
		ORDERS: {
			CREATE: "/s/orders/create",
			CREATE_DRAFT: "/s/orders/draft",
			GET: "/s/orders",
			DELETE: "/s/orders",
			EXPORT: "/s/orders/export",
		},
		TITLE_SEARCH: {
			SEARCH: "/s/titleSearch",
		},
		QUOTATION: {
			CREATE: "/s/quotations/create",
			BASE_URL: "/s/quotations/attachments",
			DOWNLOAD: "/s/quotations/download",
			PRODUCT_IMPORT: "/s/quotations",
			EDIT: "/s/quotations/",
			NEW_QUOTATION: "/s/quotations/new",
		},
		COMMENTS: {
			FIND: "/s/threads",
			CREATE: "/s/threads",
			NOTIFICATION: "/s/threads/notifications",
			COUNT: "/s/threads/count",
		},
		RATING: {
			SEARCH: "/s/ratings/search",
		}
	},
	BUYER: {
		ANALYTICS: {
			GET: "/s/analytics",
		},
		PROFILE: {
			GET: "/b/profile",
			PUT: "/b/profile",
			GET_ADDRESS: "/b/profile/addresses",
			UPDATE_PASSWORD: "/b/profile/update/password",
			DELETE: "/b/profile",
		},
		FAVORITES: {
			GET: "/b/favorites",
			UPDATE: "/b/favorites",
			DELETE: "/b/favorites",
		},
		LAST_USED: {
			GET: "/b/lastused",
			UPDATE: "/b/lastused",
		},
		ORGANISATION: {
			GET_USERS: "/b/organizations",
			BASE_URL: "/b/organizations",
			INVITE_ACCEPT: "/b/invite/accept",
			ADDRESS: {
				BASE_URL: "/address",
				SEARCH: "/address/search?",
				CREATE: "/address",
				UPDATE: "/address",
				DELETE: "/address",
			},
			USERS: {
				BASE_URL: "/users",
				SEARCH: "/users/search?",
				INVITE: "/users/invite",
				DEACTIVATE: "/deactivate",
				ACTIVATE: "/activate"
			},
			CATEGORY: "/category"
		},
		ORDERS: {
			CREATE: "/b/orders/create",
			CREATE_DRAFT: "/b/orders/draft",
			GET: "/b/orders",
			DELETE: "/b/orders",
			EXPORT: "/b/orders/export",
			ALL_SUPPLIERS: "/b/orders/suppliers",
			CANCEL: "/b/orders/cancel",
		},
		PRODUCTS: {
			SEARCH: "/b/products",
			SEARCH_ALL: "/b/products/all",
			SEARCH_SHOP: "/b/products/shop",
			DELETE: "/b/products",
			CREATE: "/b/products/register",
			UPLOAD: "/b/products/import",
			UPDATE: "/b/products/update",
			DOWNLOAD_ALL: "/b/products/export?type=all",
			DOWNLOAD: "/b/products/export?type=my-product",
			VALIDATE: "/b/products/validate",
			UPLOADS_LEFT: "/b/products/uploads-left",
			REQUEST_PRICE: "/request-price",
			RETRY_IMPORT: "/import/retry",
			PRODUCT_IMPORT: "/product/import",
			IMPORT_STATUS: "/import/status",
			ADD_TO_CART: "/b/products/addToCart",
			SEARCH_PRODUCT: "/b/product/find",

		},
		CATEGORY: {
			SEARCH: "/b/categories/search",
			DOWNLOAD: "/b/categories/export",
		},
		USERS: {
			SEARCH: "/b/users/search?",
			DELETE: "/b/users/delete?",
			CREATE: "/b/users",
		},
		QUOTATIONS: {
			SEARCH: "/b/quotations/search?",
			DELETE: "/b/quotations/delete?",
			CREATE: "/b/quotations",
			ATTACHMENT_DOWNLOAD: "/b/tenders/download",
			COMPARE: "/compare",
			AWARD: "/award"
		},
		TENDERS: {
			BASE_URL: "/b/tenders",
			SEARCH: "/b/tenders",
			DELETE: "/b/tenders",
			CREATE: "/b/tenders/create",
			EDIT: "/b/tenders",
			CREATE_DRAFT: "/b/tenders/draft",
			UPDATE_DRAFT: "/b/tenders/draft",
			SEARCH_DRAFT: "/b/tenders/draft",
			ATTACHMENTS: "/attachments",
			PRODUCT_UPLOAD: "/b/tenders/product/import",
			TENDER_DOWNLOAD: "/attachments/tender",
			QUOTATION_DOWNLOAD: "/attachments/quotation",
			SUPPLIERS_LIST: "/b/tenders/suppliers",
			NEW_TENDER: "/b/tenders/new",
			PUBLISH_TENDER: "/b/tenders/publish",
			INVITATION_MAIL: "/b/tenders/invite-supplier",
			PRODUCT_AI_PARSE: "/b/tenders/product/ai-parse",
		},
		TENDERS_PRODUCTS: {
			EXPORT: "/b/tenders",
		},
		DELIVERY: {
			SEARCH: "/b/deliveries/search?",
			DELETE: "/b/deliveries/delete?",
			CREATE: "/b/deliveries",
		},
		SUB_ORGANISATION: {
			SEARCH: "/b/sub-organisations/search?",
			DELETE: "/b/sub-organisations/delete?",
			CREATE: "/b/sub-organisations",
		},
		ROLES: {
			SEARCH: "/b/roles/search?",
			DELETE: "/b/roles/delete?",
			CREATE: "/b/roles",
		},
		TITLE_SEARCH: {
			SEARCH: "/b/titleSearch",
		},
		CONTRACT: {
			GET: "/b/contracts",
			GET_CONTRACTED_SUPPLIERS: "/b/contracts/suppliers",
			EXPORT_PRODUCTS: "/b/contracts/export"
		},
		COMMENTS: {
			START_THREAD: "/b/threads/create/comment",
			FIND: "/b/threads",
			CREATE:"/b/threads",
			NOTIFICATION: "/b/threads/notifications",
			COUNT: "/b/threads/count"
		},
		RATING: {
			RATE: "/b/ratings"
		},
		REQUEST_LOGS: {
			GET: "/b/request-logs"
		}
	},
	CORE: {
		ORGANISATION: {
			BASE: "/core/organization/"
		},
		PERMISSIONS: {
			BASE: "/core/permissions/"
		},
		RESIZE_IMAGE: {
			GET: "/core/images/"
		},
		CHANGELOG: {
			SEARCH: '/core/changelog/search',
			FUTURE: '/core/changelog/future'
		},
		MAINTENANCE: {
			NEXT: '/core/maintenance/next',
			SEARCH: '/core/maintenance/search'
		},
		UNSUBSCRIBE: {
			FIND: "/core/potential-suppliers/"
		}
	}
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
